package com.anjuros.website.templates.template6.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.toMutableStateList
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.AnjurosIcon
import com.anjuros.website.components.shared.AnjurosLogo
import com.anjuros.website.templates.template1.util.Template1ObserverViewportEntered
import com.anjuros.website.templates.template6.components.SectionTitle
import com.anjuros.website.templates.template6.modules.Template6ServiceInfo
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.util.ResKey
import com.anjuros.website.templates.template6.util.Template6ObserverViewportEntered
import com.varabyte.kobweb.compose.css.CSSLengthOrPercentageNumericValue
import com.varabyte.kobweb.compose.css.CSSTimeNumericValue
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.alignItems
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexShrink
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import kotlinx.coroutines.Delay
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.AlignItems
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgb
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Composable
fun Template6ServiceSection() {

    val animatedTranslate = remember {
        MutableList(Template6ServiceInfo.entries.size) { (15).percent }.toMutableStateList()
    }
    val breakpoint = rememberBreakpoint()
    val delay = if(breakpoint>=Breakpoint.LG) 300.ms else 0.ms
    Template6ServiceInfo.entries.forEach { service->
        Template6ObserverViewportEntered(
            sectionId = "services${service.ordinal}",
            distanceFromTop = 600.0
        ) {
            animatedTranslate[service.ordinal] = 0.percent
        }
    }
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .id("services")
            .backgroundColor(rgb(248, 249, 251))
            .padding(topBottom = 110.px),
        verticalArrangement = Arrangement.Center,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SectionTitle(
            title = ResKey.TEMPLATE6_SERVICE_TITLE,
            subtitle = ResKey.TEMPLATE6_SERVICE_SUBTITLE
        )

        SimpleGrid(
            modifier = Modifier
                .fillMaxWidth(80.percent)
                .margin(top = 60.px)
                .gap(32.px),
            numColumns = numColumns(base = 1,lg=3)
        ) {

            Template6ServiceInfo.entries.forEach { template6ServiceInfo ->
                Box(modifier = Modifier.fillMaxSize(),
                    contentAlignment = Alignment.Center) {
                    ServiceCard(
                        template6ServiceInfo = template6ServiceInfo,
                        animatedTranslate = animatedTranslate[template6ServiceInfo.ordinal],
                        delay = delay
                    )
                }

            }

        }

    }

}

@Composable
private fun ServiceCard(
   template6ServiceInfo: Template6ServiceInfo,
   animatedTranslate: CSSLengthOrPercentageNumericValue,
   delay: CSSTimeNumericValue
) {

    Column(
        modifier = Modifier
            .fillMaxSize()
            .id("services${template6ServiceInfo.ordinal}")
            .translateY(ty = animatedTranslate)
            .transition(Transition.of(property = "translate", duration = 1000.ms, delay = delay*template6ServiceInfo.ordinal
            ))
            .backgroundColor(Colors.White)
            .borderRadius(10.px)
            .padding(36.px)
            .boxShadow(
                offsetY = 6.px,
                blurRadius = 20.px,
                color = rgba(0, 0, 0, 0.4)
            )

    ) {

        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.Start
        ) {
            Box(
                modifier = Modifier
                    .size(50.px)
                    .flexShrink(0)
                    .backgroundColor(Template6Theme.Primary.getColor())
                    .borderRadius(50.percent)
                    .margin(bottom = 28.px),
                contentAlignment = Alignment.Center
            ) {

                AnjurosIcon(
                    modifier = Modifier.size(40.px),
                    src = template6ServiceInfo.icon,
                    alt = "current selection"
                )

            }

            P(
                attrs = Modifier
                    .fontSize(24.px)
                    .fontWeight(FontWeight.Bold)
                    .color(Template6Theme.Primary.getColor())
                    .margin(bottom = 26.px, left = 10.px)
                    .toAttrs()
            ) {
                Text(LocalText(template6ServiceInfo.title))
            }
        }
        template6ServiceInfo.items.forEach {

            Row(
                modifier = Modifier
                    .margin(bottom = 18.px)
                    .alignItems(AlignItems.Center)
                    .gap(4.px)
            ) {

                Image(
                    src = "portal_feature_details5.svg",
                    modifier = Modifier
                        .size(30.px)
                )

                P(
                    attrs = Modifier
                        .fontSize(18.px)
                        .color(rgb(70, 70, 70))
                        .margin(0.px)
                        .toAttrs()
                ) {
                    Text(LocalText(it))
                }

            }

        }

    }

}
